<section class="bg-(--color-secondary) py-6 text-center">
  <div class="map-content max-w-screen-2xl mx-auto px-6">
    <!-- header -->
    <div class="map-header mb-8">
      <span class="inline-flex items-center gap-2 text-(--color-main)">
        <svg class="w-5 h-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6 4l6 6-6 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        هل تريد زيارتنا؟
      </span>

      <p class="text-(--color-main) text-xl md:text-2xl font-medium mt-2">
        ندعوك لزيارة مقرنا أو أحد مشاريعنا الزراعية شخصياً. يُمكنك حجز موعد للزيارة عبر الاتصال<br />
        بنا أو عبر النموذج أعلاه. نحن نؤمن بأن الشفافية تبدأ من إتاحة الفرصة للمتعاقدين <br />لرؤية
        المشاريع على أرض الواقع.
      </p>
    </div>

    <!-- map -->
    <div class="bg-white/20 rounded-md -mx-7 my-16">
      <iframe
        title="Wills Business Location"
        class="w-full h-55 md:h-65 rounded-md"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        style="border: 0"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3452.9256529297845!2d31.34046167390725!3d30.067665517473102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583f41cc51868b%3A0x56d81e09deec70f3!2sWills%20Business!5e0!3m2!1sen!2seg!4v1770295643657!5m2!1sen!2seg"
        allowfullscreen=""
      ></iframe>
    </div>
  </div>
</section>
